import { render, staticRenderFns } from "./ChefSchedule.vue?vue&type=template&id=bf4c34ac&scoped=true&"
import script from "./ChefSchedule.vue?vue&type=script&lang=js&"
export * from "./ChefSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ChefSchedule.vue?vue&type=style&index=0&id=bf4c34ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4c34ac",
  null
  
)

export default component.exports